/**
 * Admin layout fill-mode routes: the shell content pane does not scroll.
 * The routed page fills remaining height (`flex` column) and owns inner scroll.
 *
 * Default (all other authenticated routes):
 *   padding  p-4  (shell only — pages must not add extra page padding)
 *   width    full (no max-w / mx-auto gutters)
 *   scroll   overflow-y-auto on the content pane
 *
 * Fill (`layout-content--fill`):
 *   same padding / full width
 *   content pane: flex-1 min-h-0 overflow-hidden flex flex-col
 */
export function isAdminLayoutFillRoute(url: string): boolean {
  const path = normalizePath(url);
  if (path === '/super-admin/templates/new') {
    return true;
  }
  if (path === '/parsing-engine/prompts/new') {
    return true;
  }
  if (/^\/parsing-engine\/prompts\/[^/]+\/edit$/.test(path)) {
    return true;
  }
  if (path === '/parsing-engine/confidence') {
    return true;
  }
  if (/^\/super-admin\/ticket-details\/[^/]+$/.test(path)) {
    return true;
  }
  if (path === '/super-admin/rbac') {
    return true;
  }
  return false;
}

function normalizePath(url: string): string {
  const path = url.split('?')[0].split('#')[0];
  if (path.length > 1 && path.endsWith('/')) {
    return path.replace(/\/+$/, '');
  }
  return path;
}
